import { SystemEntity } from '@erp/shared-types';
import {
  FileTextIcon,
  ListChecksIcon,
  ShoppingCartIcon,
  PackageIcon,
  EnvelopeSimpleIcon,
  FlowArrowIcon,
  PlayCircleIcon,
  CircleIcon,
  BookOpenIcon,
  FilesIcon,
  Icon,
  QuestionIcon,
  BuildingsIcon,
  FileIcon,
  ScanIcon,
  CreditCardIcon,
  ArrowsLeftRightIcon,
  CurrencyDollarIcon,
  UserIcon,
  TruckIcon,
  RobotIcon,
  CheckSquareIcon,
  TagIcon,
  LinkIcon,
  HandshakeIcon,
  ChatCircleIcon,
  ReceiptIcon,
  ChartBarIcon,
} from '@phosphor-icons/react';

/**
 * Icon mapping for system entities
 * Maps each SystemEntity to a Lucide icon component
 */
export const systemEntityIcons: Record<SystemEntity, Icon> = {
  // CORE
  [SystemEntity.CORE_MEMORY_BANK_NOTE]: BookOpenIcon,
  [SystemEntity.CORE_MEMORY_BANK_NOTE_USAGE]: FilesIcon,
  [SystemEntity.ORGANIZATION]: BuildingsIcon,
  [SystemEntity.CORE_COMPANY]: BuildingsIcon,
  [SystemEntity.CORE_FILE]: FileIcon,
  [SystemEntity.CORE_DOCUMENT]: FileIcon,
  [SystemEntity.CORE_DOCUMENT_OCR_RESULT]: ScanIcon,

  // AR
  [SystemEntity.AR_CUSTOMER]: UserIcon,
  [SystemEntity.AR_CUSTOMER_PRODUCT]: TagIcon,
  [SystemEntity.AR_STAGED_SALES_ORDER]: ShoppingCartIcon,
  [SystemEntity.AR_DISCOUNT_GROUP]: TagIcon,
  [SystemEntity.AR_DRAFT_SALES_ORDER]: ShoppingCartIcon,
  [SystemEntity.AR_SALES_ORDER]: ShoppingCartIcon,
  [SystemEntity.AR_SALES_ORDER_LINE_ITEM]: ListChecksIcon,
  [SystemEntity.AR_PAYMENT]: CreditCardIcon,
  [SystemEntity.AR_INVOICE]: FileTextIcon,
  [SystemEntity.AR_PAYMENT_APPLICATION]: ArrowsLeftRightIcon,
  [SystemEntity.AR_REMITTANCE_ADVICE]: ReceiptIcon,
  [SystemEntity.AR_CASH_RECEIPT]: ReceiptIcon,
  [SystemEntity.AR_SHIPMENT]: TruckIcon,
  [SystemEntity.AR_COLLECTION_THREAD]: ChatCircleIcon,
  [SystemEntity.AR_SAVED_REPORT]: ChartBarIcon,
  [SystemEntity.IM_TRANSFER_ORDER]: PackageIcon,
  [SystemEntity.IM_TRANSFER_ORDER_LINE_ITEM]: ListChecksIcon,
  [SystemEntity.IM_DRAFT_PURCHASE_ORDER]: PackageIcon,
  [SystemEntity.IM_PRICELIST_CASE]: TagIcon,

  // AP
  [SystemEntity.AP_INVOICE]: FileTextIcon,
  [SystemEntity.AP_INVOICE_LINE_ITEM]: ListChecksIcon,
  [SystemEntity.AP_SUPPLIER]: BuildingsIcon,
  [SystemEntity.INTERNAL_PURCHASE_ORDER]: PackageIcon,
  [SystemEntity.INTERNAL_PURCHASE_ORDER_LINE_ITEM]: ListChecksIcon,

  // FINANCE
  [SystemEntity.PAYMENT]: CreditCardIcon,
  [SystemEntity.FINANCIAL_TRANSACTION]: ArrowsLeftRightIcon,
  [SystemEntity.CHARGE]: CurrencyDollarIcon,

  // REBATES
  [SystemEntity.REBATE_AGREEMENT]: HandshakeIcon,

  // PRICING
  [SystemEntity.PRICING_SPA]: FileTextIcon,

  // SUPPLY CHAIN MANAGEMENT
  [SystemEntity.SCM_SHIPMENT]: TruckIcon,

  // EMAILS
  [SystemEntity.INBOUND_EMAIL]: EnvelopeSimpleIcon,
  [SystemEntity.OUTBOUND_EMAIL]: EnvelopeSimpleIcon,

  // WORKFLOWS
  [SystemEntity.WORKFLOW_DEFINITION]: FlowArrowIcon,
  [SystemEntity.WORKFLOW_RUN]: PlayCircleIcon,
  [SystemEntity.WORKBOOK]: BookOpenIcon,
  [SystemEntity.STEP_RUN]: CircleIcon,

  // AI
  [SystemEntity.AI_AGENT_RUN]: RobotIcon,
  [SystemEntity.AI_EXTRACTION_RESULT]: FileTextIcon,
  [SystemEntity.TASK]: CheckSquareIcon,

  // EXTERNAL REFERENCES
  [SystemEntity.EXTERNAL_SYSTEM_REFERENCE]: LinkIcon,
};

/**
 * Get the icon for a system entity
 */
export function getEntityIcon(entityType: SystemEntity): Icon {
  return systemEntityIcons[entityType] ?? QuestionIcon;
}
